import React from "react";
import {alphaFromHex} from "../../util/colors";

export default function MarketplacePageHeader({title, subtitle, colors, children}) {
    return <div className="card border-0 shadow-sm mb-4" style={{borderRadius: 18, overflow: "hidden", border: `1px solid ${alphaFromHex(colors.primary, 0.14)}`}}>
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center" style={{gap: 18, padding: "20px 22px"}}>
            <div><h4 className="mb-1" style={{fontWeight: 900}}>{title}</h4><p className="text-muted mb-0">{subtitle}</p></div>
            {children}
        </div>
    </div>;
}
